import { render, staticRenderFns } from "./peaAgreement.vue?vue&type=template&id=2ed6aafe&scoped=true&"
import script from "./peaAgreement.vue?vue&type=script&lang=js&"
export * from "./peaAgreement.vue?vue&type=script&lang=js&"
import style0 from "./peaAgreement.vue?vue&type=style&index=0&id=2ed6aafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6aafe",
  null
  
)

export default component.exports